import Emitter from '../../../services/eventEmmiter/EventEmmiter';
import { EventTypes } from '../../../services/eventEmmiter/EventTypes';
import * as style from './style.css';
import React = require('react');

interface IProps {
    singleMessage: boolean;
}

interface IState {
    messages: IMessageItem[];

}
interface IMessageItem {
    message: string;
    validTo: Date;

}
export default class Messages extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            messages: []
        };
    }

    componentDidMount() {
        Emitter.on(EventTypes.Message, (m: string) => this.addMessage(m));
        window.setInterval(() => this.processMessages(), 5000);
    }

    processMessages() {
        const now = new Date();
        const messages = this.state.messages.filter(x => x.validTo > now);
        this.setState({ messages: messages });
    }

    addMessage(m: string) {
        let messages = this.state.messages;
        if (this.props.singleMessage) { messages = []; }
        const date = new Date();
        date.setSeconds(date.getSeconds() + 5);
        messages.push({
            message: m,
            validTo: date
        });
        this.setState({ messages: messages });
    }

    render() {
        if (this.state.messages.length === 0) {
            return <></>;
        }
        return (<div className={style.messagesWrapper}>

            {this.state.messages.map((n, i) => this.renderMessage(n.message, i))}
        </div>);
    }

    renderMessage(m: string, index: number): any {
        return (<div key={index} className={style.messageItem}>
            {m}
            <span onClick={() => this.onCloseClick(index)} className="material-icons">check_circle_outline</span>
        </div>);
    }

    onCloseClick(index: number): void {
        const messages = this.state.messages;
        messages.splice(index, 1);
        this.setState({ messages: messages });
    }
}
